import { LOCALE_SEPARATOR } from 'state/intl/constants';
import { LANGUAGES, LanguageAndRegionFromLocaleString, REGIONS } from 'state/intl/types';

export const getLanguageAndRegionFromLocaleString = (
  localeString: string = ''
): LanguageAndRegionFromLocaleString => {
  const [languageStr, regionStr] = localeString.split(LOCALE_SEPARATOR, 2);
  return [LANGUAGES[languageStr], REGIONS[regionStr]];
};
